import React from 'react'
import { styled } from '@mui/system'
import { CardHeader, FormControlLabel, Grid, Switch, Typography } from '@mui/material'
import { generateUtilityClasses } from '@mui/material'
import { CheckboxField } from '../../../../../../ui'
import { Field } from 'react-final-form'

const classes = generateUtilityClasses('Grid', ['root'])

const StyledGrid = styled(Grid)(() => ({
  [`&.${classes.root}`]: {},
}))

interface Props {}

export const TitleForm = ({}: Props) => {
  return (
    <>
      <CardHeader title='Title' />
      <Grid container spacing={2} padding={3}>
        <Grid item xs={12} sm={4} md={3}>
          <Field name='IncludeinSalespersonDropdowns'>
            {(props) => (
              <FormControlLabel
                sx={{ width: '100%' }}
                control={
                  <Switch
                    name={props.input.name}
                    checked={props.input.value}
                    onChange={(e) => {
                      props.input.onChange(e.target.checked)
                    }}
                  />
                }
                labelPlacement='end'
                label='Include in Salesperson Dropdowns'
              />
            )}
          </Field>
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <Field name='IncludeinFIManagerDropdowns'>
            {(props) => (
              <FormControlLabel
                sx={{ width: '100%' }}
                control={
                  <Switch
                    name={props.input.name}
                    checked={props.input.value}
                    onChange={(e) => {
                      props.input.onChange(e.target.checked)
                    }}
                  />
                }
                labelPlacement='end'
                label='Include in F&I Manager Dropdowns'
              />
            )}
          </Field>
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <Field name='IncludeinCollectorDropdowns'>
            {(props) => (
              <FormControlLabel
                sx={{ width: '100%' }}
                control={
                  <Switch
                    name={props.input.name}
                    checked={props.input.value}
                    onChange={(e) => {
                      props.input.onChange(e.target.checked)
                    }}
                  />
                }
                labelPlacement='end'
                label='Include in Collector Dropdowns'
              />
            )}
          </Field>
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <Field name='IncludeinManagerDropdowns'>
            {(props) => (
              <FormControlLabel
                sx={{ width: '100%' }}
                control={
                  <Switch
                    name={props.input.name}
                    checked={props.input.value}
                    onChange={(e) => {
                      props.input.onChange(e.target.checked)
                    }}
                  />
                }
                labelPlacement='end'
                label='Include in Manager Dropdowns'
              />
            )}
          </Field>
        </Grid>
      </Grid>
    </>
  )
}

export default TitleForm
